namespace GeniuzPOS.Inventory {
    export class IcStockDisassembleDtColumns {
        static columnsKey = 'Inventory.IcStockDisassembleDt';
    }
}
